
<template>
	<div class="box">
	  <div class="boxTitle">中国与七大洲贸易额</div>
	  <div class="echart">
	    <dv-active-ring-chart :config="config" style="width:250px;height:18vh" />
	  </div>
	</div>
</template>

<script>
	export default {
		name: "One",
		props: {
			imagePreview: {
				type: String,
        value:''
			},

		},
		data() {
			return {
        config:{
        radius: '40%',
        activeRadius: '45%',
        data: [
          {
            name: '亚洲',
            value: 55
          },
          {
            name: '非洲',
            value: 120
          },
          {
            name: '北美洲',
            value: 78
          },
          {
            name: '南美洲',
            value: 66
          },
          {
            name: '南极洲',
            value: 80
          },
          {
            name: '欧洲',
            value: 80
          },
          {
            name: '大洋洲',
            value: 80
          }
        ],
        digitalFlopStyle: {
          fontSize: 20
        }
			}
		}
	}
}
</script>

<style>
  .echart{
    display:flex;
    justify-content:center;
  }
</style>



// WEBPACK FOOTER //
// src/components/right/five.vue